module.exports = __webpack_public_path__ + "static/media/charts1.17ca8938.jpg";